export class AllocatedLocationReq {
    sampleRequestItemId: number;
    action:string;
    type?:string;
}